import Speaker9 from "../../assets/img/success/speakers/9.png";
import Speaker10 from "../../assets/img/success/speakers/10.png";
import Speaker11 from "../../assets/img/success/speakers/11.png";
import Speaker12 from "../../assets/img/success/speakers/12.png";
import Speaker13 from "../../assets/img/success/speakers/13.png";
import Speaker14 from "../../assets/img/success/speakers/14.png";
import Speaker15 from "../../assets/img/success/speakers/15.png";
import Speaker16 from "../../assets/img/success/speakers/16.png";
import Gallery from "react-grid-gallery";

const images = [
  {
    src: Speaker9,
    thumbnail: Speaker9,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
  {
    src: Speaker10,
    thumbnail: Speaker10,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
  {
    src: Speaker11,
    thumbnail: Speaker11,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
  {
    src: Speaker12,
    thumbnail: Speaker12,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
  {
    src: Speaker13,
    thumbnail: Speaker13,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
  {
    src: Speaker14,
    thumbnail: Speaker14,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
  {
    src: Speaker15,
    thumbnail: Speaker15,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
  {
    src: Speaker16,
    thumbnail: Speaker16,
    thumbnailWidth: 340,
    thumbnailHeight: 340,
  },
];

const SuccessSpeakersTwo = () => {
  return (
    <div className="success_conference">
      <section>
        <h3>
          Prelegenci konferencji inaugurującej projekt w roku szkolnym 2024/2025
        </h3>
        <div className="speakers">
          <Gallery images={images} margin={0} enableImageSelection={false} />
        </div>
      </section>
    </div>
  );
};

export default SuccessSpeakersTwo;
